// import actions from './actions';

const initState = {
    fileLists: []
}

export default function gocarReducer(state = initState, {type, payload}) {
    switch (type) {
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/redux/upload/reducer.js